import { Categories } from './categories.model';
import { CategoryFeatureMetadata } from './category-feature-metadata-model';
import { GameMetaDataMap } from './game-metadata.model';

export class LobbyItemBaseModel {
    lsCategoriesMap: [string, Categories][];
    lsCategorytNameLangMap: [string, string][];
    lsStickerNameMap: [string, string][];
    lsGameMetaDataMap: [string, GameMetaDataMap][];
    catVsFeatureMetadata: Map<string, CategoryFeatureMetadata>;
    lbyTempName: string;
    lbyTargetType: string;
    lobbyGameIconImageSuffix: string;
    optSegName?: string;
    lsCatVsFeatureMetadata: [string, CategoryFeatureMetadata][];
}
